// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { CartLineModel, LanguageModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { getSettingsCollection } from "@vanmeter/App/Store/Selectors/SettingsSelectors";
import { sharedDateTimeOptions } from "@vanmeter/XDL/constants";
import { parseBoolean } from "@vanmeter/XDL/Utilities";
import parse from "html-react-parser";

export const xCanSeePrices = (state: ApplicationState): boolean => {
    const settings = getSettingsCollection(state);
    const canSeePrices = settings.productSettings.canSeePrices;

    const showPricingAvailability = parseBoolean(settings?.customSettings?.showPricingAvailability);
    return canSeePrices && showPricingAvailability;
};

export const getLastPurchasedOn = (product: ProductModel | CartLineModel, language?: LanguageModel | null) => {
    if (product.properties.lastPurchasedOn) {
        const date = getLocalizedDateTime({
            dateTime: new Date(product.properties.lastPurchasedOn),
            language,
            options: {
                ...sharedDateTimeOptions,
            },
        });

        return parse(`Prev.<b>${date}</b>`, parserOptions);
    }
};
